import React from "react";
import { useRubyContent } from "~/hooks/useRubyContent";
import { cn } from "~/lib/utils";

export function H1({
  children,
  className,
  rubyContent,
}: {
  children?: React.ReactNode;
  className?: string;
  rubyContent?: string;
}) {
  const parsedContent = useRubyContent(rubyContent);
  const baseClassName =
    "scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl";

  return (
    <h1 className={cn(baseClassName, className)}>
      {parsedContent ?? children}
    </h1>
  );
}

export function H2({
  children,
  className,
  rubyContent,
}: {
  children?: React.ReactNode;
  className?: string;
  rubyContent?: string | null;
}) {
  const parsedContent = useRubyContent(rubyContent);
  const baseClassName = "scroll-m-20 text-3xl font-semibold tracking-tight";

  return (
    <h2 className={cn(baseClassName, className)}>
      {parsedContent ?? children}
    </h2>
  );
}

export function H3({
  children,
  className,
  rubyContent,
}: {
  children: React.ReactNode;
  className?: string;
  rubyContent?: string | null;
}) {
  const parsedContent = useRubyContent(rubyContent);
  return (
    <h3
      className={cn(
        "text-md scroll-m-20 font-semibold tracking-tight md:text-xl",
        className,
      )}
    >
      {parsedContent ?? children}
    </h3>
  );
}

export function H4({
  children,
  className,
  rubyContent,
}: {
  children: React.ReactNode;
  className?: string;
  rubyContent?: string | null;
}) {
  const parsedContent = useRubyContent(rubyContent);
  return (
    <h4
      className={cn(
        "scroll-m-20 text-xl font-semibold tracking-tight",
        className,
      )}
    >
      {parsedContent ?? children}
    </h4>
  );
}
